import * as T from "../constants";

const suggestedCorrectedAddressReducer = (state = "", action) => {
    const { type } = action;

    switch (type) {
        case T.RIGHT_TO_CORRECT.SUGGESTED_CORRECTED_ADDRESS_REQUESTED_SUCCESS:
            return action.payload
            
        case T.RIGHT_TO_CORRECT.SUGGESTED_CORRECTED_ADDRESS_REQUESTED_FAIL:
            return action.payload
            
        default:
            return state;
    }
}

export default suggestedCorrectedAddressReducer;